import { Link } from 'react-router-dom';

interface NotFoundStateProps {
  readonly title?: string;
  readonly description?: string;
  readonly homePath?: string;
}

/**
 * 404 state. Used when an endpoint returns `not_found` (per `docs/10 §5.2`,
 * which collapses cross-tenant probes here too — the frontend never reveals
 * whether the resource exists in another tenant).
 */
export function NotFoundState({
  title = 'لم يتم العثور على المورد',
  description = 'الصفحة أو السجل غير موجود، أو لا يمكن الوصول إليه من هذا الحساب.',
  homePath = '/app',
}: NotFoundStateProps) {
  return (
    <div className="state">
      <div className="glyph" style={{ background: 'var(--cream-2)', color: 'var(--ink-2)' }}>
        <svg viewBox="0 0 24 24">
          <circle cx="11" cy="11" r="7" />
          <path d="M21 21l-4-4" />
        </svg>
      </div>
      <h3>{title}</h3>
      <p>{description}</p>
      <Link to={homePath} className="btn btn-ghost btn-sm">
        العودة للرئيسية
      </Link>
    </div>
  );
}
